
/* ==== quick-shop-mobile-fix.js ==== */
;/**
 * Quick Shop — Mobile Popup Fix
 *
 * The mobile quick-shop drawer uses `position: fixed` on its wrapper to
 * float over the viewport. If ANY ancestor has a transform / filter /
 * will-change / contain, the fixed positioning gets trapped inside that
 * ancestor and the drawer appears pinned to the product card instead of
 * the viewport.
 *
 * This script relocates the <quick-shop> element to <body> the moment it
 * becomes active on mobile, and returns it to its original parent on
 * close. Desktop behavior (Magnific Popup modal) is untouched.
 */
(function () {
  'use strict';

  var MOBILE_BRKP = 768; // matches theme.mobileBrkp

  function isMobile() {
    return window.innerWidth < MOBILE_BRKP;
  }

  function setupQuickShop(qs) {
    if (qs.__mobilePopupPatched) return;
    qs.__mobilePopupPatched = true;

    // Remember original home so we can move it back on close.
    var originalParent = qs.parentElement;
    var originalNextSibling = qs.nextSibling;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName !== 'class') return;

        var isActive = qs.classList.contains('active');

        if (isActive && isMobile() && qs.parentElement !== document.body) {
          // Remember current home (could have changed) and move to body.
          originalParent = qs.parentElement;
          originalNextSibling = qs.nextSibling;
          qs.classList.add('quick-shop--mobile-popup');
          document.body.appendChild(qs);
        } else if (!isActive && qs.parentElement === document.body) {
          // Put it back so the theme's normal logic still works.
          qs.classList.remove('quick-shop--mobile-popup');
          if (originalParent && originalParent.isConnected) {
            if (originalNextSibling && originalNextSibling.parentElement === originalParent) {
              originalParent.insertBefore(qs, originalNextSibling);
            } else {
              originalParent.appendChild(qs);
            }
          }
        }
      });
    });

    observer.observe(qs, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    document.querySelectorAll('quick-shop').forEach(setupQuickShop);

    // Catch quick-shops added later (e.g., by ajax product loads, infinite scroll).
    var bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName && node.tagName.toLowerCase() === 'quick-shop') {
            setupQuickShop(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('quick-shop').forEach(setupQuickShop);
          }
        });
      });
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==== rooster-final-sale.js ==== */
;/**
 * rooster-final-sale.js — 2026-08-28
 *
 * Two jobs, both about the `_final_sale` line item property.
 *
 * ---------------------------------------------------------------------------
 * 1. Stop a null dereference from killing the `variants:change` event
 * ---------------------------------------------------------------------------
 * theme.js `VariantSelects.toggleAddButton()` guards `addButton` and then
 * dereferences `addButtonText` (`[name="add"] > span`) anyway:
 *
 *     const addButton     = productForm.querySelector('[name="add"]');
 *     const addButtonText = productForm.querySelector('[name="add"] > span');
 *     if (!addButton) return;                                  // wrong element
 *     addButton.removeAttribute('disabled');
 *     addButtonText.textContent = window.theme.t.add_to_cart;  // throws if null
 *
 * `setUnavailable()` has the same shape. The span is gone whenever the Klaviyo
 * back-in-stock script has rewritten the button to "Notify me when back", so on
 * any product with a sold-out variant the call throws, and the throw aborts
 * `onVariantChange()` BEFORE its closing
 * `dispatchEvent(new CustomEvent('variants:change'))`.
 *
 * rooster-commerce.js `syncFinalSale()` listens for that event. No event, no
 * sync — so the hidden `properties[_final_sale]` input freezes at whatever the
 * server rendered for the FIRST variant loaded. Switch from a marked-down
 * variant to a full-price one and the flag stays on; switch the other way and
 * it never turns on. Measured across 300 orders: 24 discounted line items, only
 * 3 flagged.
 *
 * Rather than hand-edit the minified bundle the live site actually loads, we
 * wrap the two methods on the custom element prototypes so an exception inside
 * them can never again stop the event from firing.
 *
 * Trade-off: swallowing the error means the button label may not update on that
 * one call. That label is already owned by pdp-back-in-stock.js and
 * rb-combined-listing-fix.js in exactly the case where this throws, so the
 * label was never going to be theme.js's to set. A dropped label beats a dead
 * event bus.
 *
 * ---------------------------------------------------------------------------
 * 2. One shared definition of "is this variant on sale"
 * ---------------------------------------------------------------------------
 * Six add-to-cart paths can put a line in the cart. Four re-implemented this
 * test independently; two never implemented it at all. `window.RoosterFinalSale
 * .forVariant()` is now the single definition for new call sites.
 *
 * Unit note: `/products/<handle>.js` returns prices as integer CENTS while
 * `/collections/<h>/products.json` and `/recommendations/products.json` return
 * DOLLAR strings. Both fields always come off the same variant object, so
 * comparing them to each other is unit-safe either way. Do not mix objects.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------ shared predicate */

  function forVariant(variant) {
    if (!variant) return false;
    var cap = variant.compare_at_price;
    if (cap === null || cap === undefined || cap === '') return false;
    var compareAt = parseFloat(cap);
    var price = parseFloat(variant.price);
    if (!isFinite(compareAt) || !isFinite(price)) return false;
    return compareAt > price;
  }

  // Cart payload fragment: spread into a /cart/add.js body.
  function properties(isFinalSale) {
    return isFinalSale ? { _final_sale: 'true' } : {};
  }

  window.RoosterFinalSale = { forVariant: forVariant, properties: properties };

  /* -------------------------------------------- keep variants:change alive */

  var GUARDED = ['toggleAddButton', 'setUnavailable', 'renderProductInfo'];

  function guard(proto, name) {
    var original = proto[name];
    if (typeof original !== 'function') return;
    var wrapped = function () {
      try {
        return original.apply(this, arguments);
      } catch (err) {
        // Deliberately swallowed: see the header note. Logged so a real
        // regression is still visible in the console.
        if (window.console && console.warn) {
          console.warn('[rooster-final-sale] ' + name + ' threw, continuing so ' +
                       'variants:change still fires —', err);
        }
        return undefined;
      }
    };
    wrapped.__roosterGuarded = true;
    proto[name] = wrapped;
  }

  function patch(tagName) {
    var Ctor;
    try { Ctor = window.customElements && customElements.get(tagName); } catch (e) { return; }
    if (!Ctor || !Ctor.prototype) return;
    var proto = Ctor.prototype;
    if (proto.__roosterFinalSalePatched) return;
    GUARDED.forEach(function (name) {
      // Walk to wherever the method actually lives (VariantRadios inherits
      // these from VariantSelects) so we wrap the real implementation once.
      var owner = proto;
      while (owner && !Object.prototype.hasOwnProperty.call(owner, name)) {
        owner = Object.getPrototypeOf(owner);
      }
      if (!owner) return;
      if (owner[name] && owner[name].__roosterGuarded) return;
      guard(owner, name);
    });
    proto.__roosterFinalSalePatched = true;
  }

  /* --------------------------------- create/remove the inputs, don't disable */

  /* The inputs are no longer rendered `disabled` when the variant is full
     price — they are not rendered AT ALL. A disabled input still carries its
     value in the page source, and a client that parses the HTML and posts
     every name/value pair (instead of running this JS) submits it regardless.
     So the only safe state for "not on sale" is absent.

     That means the JS can no longer just flip .disabled — it has to add the
     inputs when a shopper picks a markdown and remove them when they pick a
     full-price variant. */
  function ensure(form, on, cap, price, src) {
    if (!form) return;
    var flag  = form.querySelector('[data-final-sale-property], .js-quick-add-final-sale');
    var basis = form.querySelector('[data-final-sale-basis], .js-quick-add-fs-basis');

    if (!on) {
      if (flag  && flag.parentNode)  flag.parentNode.removeChild(flag);
      if (basis && basis.parentNode) basis.parentNode.removeChild(basis);
      return;
    }

    var isQuickAdd = (src === 'quickadd');
    if (!flag) {
      flag = document.createElement('input');
      flag.type = 'hidden';
      flag.name = 'properties[_final_sale]';
      flag.value = 'true';
      if (isQuickAdd) flag.className = 'js-quick-add-final-sale';
      else flag.setAttribute('data-final-sale-property', '');
      form.appendChild(flag);
    }
    flag.disabled = false;

    if (!basis) {
      basis = document.createElement('input');
      basis.type = 'hidden';
      basis.name = 'properties[_fs_basis]';
      if (isQuickAdd) basis.className = 'js-quick-add-fs-basis';
      else basis.setAttribute('data-final-sale-basis', '');
      form.appendChild(basis);
    }
    basis.disabled = false;
    basis.value = 'cap:' + (cap == null ? '' : cap) + '|price:' + price + '|src:' + src;
  }

  window.RoosterFinalSale.ensure = ensure;

  /* ------------------------------------------- keep _fs_basis in step (PDP) */

  /* The basis input's `disabled` is rendered by Liquid from the FIRST variant
     loaded. rooster-commerce.js re-syncs only [data-final-sale-property] on
     variant change, so without this the basis would stay disabled (and stale)
     whenever the shopper switches to a marked-down variant — the flag would
     ship with no audit trail, which defeats the point of having one. */
  document.addEventListener('variants:change', function (event) {
    var variant = event.detail && event.detail.variant;
    var box = null;
    try { box = event.target && event.target.closest && event.target.closest('.product-single__box'); } catch (e) {}
    var form = box
      ? box.querySelector('form[action*="/cart/add"]')
      : document.querySelector('.product-single form[action*="/cart/add"]');
    if (!form) return;
    if (!variant) { ensure(form, false); return; }
    ensure(form, forVariant(variant), variant.compare_at_price, variant.price, 'pdp');
  }, true);

  /* ------------------------------------------------ last line of defence */

  /* A legitimate flag ALWAYS has a compare-at behind it: the same variant that
     made `compare_at_price > price` true is the one that fills `cap:`. So a
     flag whose basis reads `cap:|...` is self-contradictory and wrong, whatever
     put it there.

     Twice now a full-price item has reached checkout carrying `_final_sale`
     with an empty cap (#105486 Blue Midnight, #105761 Home Sweet Home) from a
     form whose inputs the server rendered `disabled`. The cause is still not
     identified. This does not need it: right before the form is submitted, if
     the flag is live but its basis has no compare-at, strip the flag.

     It cannot suppress a real markdown — those always carry a cap. It only
     removes flags that contradict their own evidence. */
  function assertConsistent(form) {
    if (!form) return;
    var flag = form.querySelector('[data-final-sale-property], .js-quick-add-final-sale');
    if (!flag || flag.disabled) return;
    var basis = form.querySelector('[data-final-sale-basis], .js-quick-add-fs-basis');
    var val = basis ? String(basis.value || '') : '';
    var m = val.match(/cap:([^|]*)/);
    var cap = m ? m[1].trim() : '';
    var capNum = parseFloat(cap);
    if (cap === '' || !isFinite(capNum) || capNum <= 0) {
      // REMOVE, do not merely disable. Shopify's accelerated checkout collector
      // (Sn() in portable-wallets.en.js) reads properties[...] inputs by name and
      // never looks at `disabled`, so disabling is not a strip at all on the
      // Buy-it-now path. Only absence from the DOM is.
      if (flag.parentNode) flag.parentNode.removeChild(flag);
      if (basis && basis.parentNode) basis.parentNode.removeChild(basis);
      if (window.console && console.warn) {
        console.warn('[rooster-final-sale] stripped a final-sale flag with no ' +
                     'compare-at behind it. basis was:', val || '(no basis input)');
      }
    }
  }

  // Capture phase, so this runs before jQuery's submit handler serializes.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    assertConsistent(form);
  }, true);

  // The JS add paths call requestSubmit()/submit() or post directly; catch the
  // click before they read the form.
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[name="add"], .js-quick-add-confirm-btn, .js-rb-qa-add, .js-quick-add-submit');
    if (!btn) return;
    assertConsistent(btn.closest('form[action*="/cart/add"]'));
  }, true);

  window.RoosterFinalSale.assertConsistent = assertConsistent;

  /* ------------------------------------------ reconcile on FIRST PAINT */

  /* `variants:change` only fires when the shopper CHANGES variant. It never
     fires for the variant that is already selected on load — measured: clicking
     the already-checked swatch on dillon-pocket-flannel produced zero events.

     So before this, the default variant's flag was whatever Liquid decided,
     with no client-side check either direction. For a marked-down default that
     is the dangerous case: if the Liquid expression were ever wrong (nil
     handling, a Markets currency conversion, a rounding edge) the item ships
     unflagged and nothing catches it.

     initialSync() re-derives the answer from the server-rendered price map in
     [data-pdp-fs-map] and calls the same ensure() that the change path uses —
     the one already verified against all 40 variants of the two hardest
     products. Liquid and the JS now have to agree; the JS wins. */
  function initialSync() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      var box = form.closest ? form.closest('.product-single, .product-single__box') : null;
      var scope = box || document;
      var mapEl = scope.querySelector('[data-pdp-fs-map]') ||
                  document.querySelector('[data-pdp-fs-map]');
      if (!mapEl) continue;

      var map;
      try { map = JSON.parse(mapEl.textContent || '{}'); } catch (e) { continue; }

      var idEl = form.querySelector('input[name="id"]');
      var id = idEl && idEl.value;
      var row = id && map[id];
      if (!row) continue;

      var cap = row[0], price = row[1];
      var onSale = cap !== null && cap !== undefined && cap !== '' &&
                   isFinite(parseFloat(cap)) && parseFloat(cap) > parseFloat(price);

      // Log a disagreement rather than silently papering over it — if Liquid and
      // the map ever diverge, that is a bug worth seeing.
      var rendered = !!form.querySelector('[data-final-sale-property]:not([disabled])');
      if (rendered !== onSale && window.console && console.warn) {
        console.warn('[rooster-final-sale] first-paint disagreement on variant ' + id +
                     ': Liquid rendered flag=' + rendered + ', price map says onSale=' +
                     onSale + ' (cap=' + cap + ', price=' + price + '). Using the map.');
      }
      ensure(form, onSale, cap, price, 'pdp');
    }
  }

  window.RoosterFinalSale.initialSync = initialSync;

  function run() {
    patch('variant-selects');
    patch('variant-radios');
    initialSync();
  }

  run();
  if (window.customElements && customElements.whenDefined) {
    ['variant-selects', 'variant-radios'].forEach(function (tag) {
      customElements.whenDefined(tag).then(run).catch(function () {});
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  }
})();


/* ==== quick-add-overlay.js ==== */
;/*
 * Hover quick-add overlay (Huckberry-style) — 2-step size flow.
 *
 * Each .js-quick-add-overlay block on the page is one product's overlay. Inside:
 *   - a Shopify product form (action=/cart/add) that's already wired into the
 *     theme's existing ajaxCart plugin via the .js-product-form class
 *   - a JSON variant map: [[variant_id, color_value, size_value, available, final_sale], ...]
 *   - one button.js-quick-add-pill per size value (for products with sizes),
 *     OR a single submit button (for products without)
 *
 * Click flow (sized products):
 *   1. User clicks a size pill
 *   2. We resolve (currentColor × clickedSize) → variant_id via the variant map
 *   3. The pill grid is swapped for an "Add to Cart" button labeled with the
 *      selected size. The user clicks that button to actually add.
 *   4. Add to cart button submits the form — ajaxCart intercepts, posts to
 *      /cart/add, opens drawer. The overlay then resets to show pills again.
 *
 * Color sync:
 *   The collection card already has a color-swatch row that swaps the card image
 *   on click (ProductCardSwatches in theme.js). We hook the same click events to
 *   update each overlay's "current color" so the next size-pill click resolves
 *   to the right (color × size) variant.
 */
(function() {
  function closestFrom(node, selector) {
    // Click targets are not always Elements (library-dispatched events can land on
    // document, window or a text node) and only Element has closest().
    if (!node || typeof node.closest !== 'function') return null;
    return node.closest(selector);
  }

  "use strict";

  function $$(sel, parent) {
    return Array.prototype.slice.call((parent || document).querySelectorAll(sel));
  }

  function setTriggerState(trigger, open) {
    if (!trigger) return;
    trigger.setAttribute("aria-expanded", open ? "true" : "false");
    var label = open ? trigger.dataset.closeLabel : trigger.dataset.openLabel;
    if (label) trigger.setAttribute("aria-label", label);
  }

  function readVariantMap(overlay) {
    var node = overlay.querySelector(".js-quick-add-variants");
    if (!node) return [];
    try {
      var data = JSON.parse(node.textContent);
      // Each row: [id, color, size, available, finalSale]
      return data.map(function(row) {
        return { id: row[0], color: row[1] || "", size: row[2] || "", available: !!row[3], finalSale: !!row[4],
                 cap: (row.length > 5 ? row[5] : null), price: (row.length > 6 ? row[6] : "") };
      });
    } catch (e) {
      console.warn("quick-add-overlay: bad variant map", e);
      return [];
    }
  }

  function syncFinalSaleProperty(overlay, variantId) {
    // 2026-09-04: the inputs are no longer rendered `disabled` on full-price
    // tiles - they are not rendered at all, because Shopify's accelerated
    // checkout collector ignores `disabled` (portable-wallets.en.js, Sn()).
    // So this has to CREATE and REMOVE them, not toggle a property that may
    // not exist. RoosterFinalSale.ensure() does exactly that.
    var form = overlay.querySelector("form");
    if (!form) return;
    var match = readVariantMap(overlay).filter(function(variant) {
      return String(variant.id) === String(variantId);
    })[0];
    var on = !!(match && match.finalSale);
    if (window.RoosterFinalSale && window.RoosterFinalSale.ensure) {
      window.RoosterFinalSale.ensure(form, on, match ? match.cap : null,
                                     match ? match.price : "", "quickadd");
      return;
    }
    // Fallback if the helper failed to load: toggle whatever is there. Safe
    // direction only - never leaves a flag on a full-price variant.
    var property = form.querySelector(".js-quick-add-final-sale");
    var basis = form.querySelector(".js-quick-add-fs-basis");
    if (property && !on && property.parentNode) property.parentNode.removeChild(property);
    if (basis && !on && basis.parentNode) basis.parentNode.removeChild(basis);
  }

  function refreshPillState(overlay) {
    var color = overlay.dataset.currentColor || "";
    var variants = readVariantMap(overlay);
    var pills = $$(".js-quick-add-pill", overlay);

    pills.forEach(function(pill) {
      var size = pill.dataset.size || "";
      // Find a variant matching (color, size). If multiple variants match
      // (shouldn't happen in a normal catalog), prefer an available one.
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.color === color && v.size === size) {
          if (!match || v.available) match = v;
        }
      }
      if (!match) {
        pill.disabled = true;
        pill.removeAttribute("data-variant-id");
        pill.title = "Unavailable";
        return;
      }
      if (!match.available) {
        pill.disabled = true;
        pill.dataset.variantId = String(match.id);
        pill.title = "Sold out";
      } else {
        pill.disabled = false;
        pill.dataset.variantId = String(match.id);
        pill.title = "";
      }
    });
  }

  function setCurrentColor(overlay, color) {
    overlay.dataset.currentColor = color || "";
    // Color change invalidates any pending size selection — reset to pills.
    resetSelection(overlay);
    refreshPillState(overlay);
    if (!overlay.querySelector(".js-quick-add-pill")) {
      var colorVariant = readVariantMap(overlay).filter(function(variant) {
        return variant.available && variant.color === (color || "");
      })[0];
      var idInput = overlay.querySelector(".js-quick-add-id");
      if (colorVariant && idInput) {
        idInput.value = colorVariant.id;
        syncFinalSaleProperty(overlay, colorVariant.id);
      }
    }
    // If a sidebar size filter is active, re-apply it for the new color
    // (the variant id will differ from the previous color's variant id).
    autoSelectFromSidebar(overlay, getActiveSidebarSizes());
  }

  function ensureConfirmUI(overlay) {
    // Confirm UI is now rendered server-side by product-grid-item.liquid.
    // Fall back to JS injection if an older card markup is on the page.
    var confirm = overlay.querySelector(".js-quick-add-confirm");
    if (confirm) return confirm;
    var form = overlay.querySelector(".js-product-form");
    if (!form) return null;
    confirm = document.createElement("div");
    confirm.className = "quick-add-overlay__confirm js-quick-add-confirm";
    confirm.innerHTML =
      '<button type="button" class="quick-add-overlay__btn quick-add-overlay__btn--confirm js-quick-add-confirm-btn">' +
        '<span class="js-quick-add-confirm-label">Add to Cart</span>' +
      '</button>' +
      '<button type="button" class="quick-add-overlay__change js-quick-add-change" aria-label="Change size">Change size</button>';
    form.appendChild(confirm);
    return confirm;
  }

  function showConfirm(overlay, pill) {
    var confirm = ensureConfirmUI(overlay);
    if (!confirm) return;
    var label = confirm.querySelector(".js-quick-add-confirm-label");
    var size = pill.dataset.size || "";
    if (label) label.textContent = size ? "Add to Cart — " + size : "Add to Cart";
    overlay.dataset.selectedVariantId = pill.dataset.variantId || "";
    overlay.dataset.selectedSize = size;
    overlay.classList.add("is-size-selected");
  }

  function resetSelection(overlay) {
    overlay.classList.remove("is-size-selected");
    overlay.removeAttribute("data-selected-variant-id");
    overlay.removeAttribute("data-selected-size");
    var btn = overlay.querySelector(".js-quick-add-confirm-btn");
    if (btn) {
      btn.classList.remove("is-loading", "is-added", "is-error");
    }
  }

  function submitAdd(overlay, variantId, btn) {
    var form = overlay.querySelector(".js-product-form");
    if (!form) return;
    var idInput = form.querySelector(".js-quick-add-id");
    if (idInput) idInput.value = variantId;
    syncFinalSaleProperty(overlay, variantId);

    var label = btn.querySelector(".js-quick-add-confirm-label");
    var originalText = label ? label.textContent : btn.textContent;
    btn.classList.remove("is-added", "is-error");
    btn.classList.add("is-loading");
    if (label) label.textContent = "Adding…";

    var $ = window.jQuery;
    var done = function(success) {
      btn.classList.remove("is-loading");
      btn.classList.add(success ? "is-added" : "is-error");
      if (label) label.textContent = success ? "Added ✓" : "Try again";
      setTimeout(function() {
        btn.classList.remove("is-added", "is-error");
        if (label) label.textContent = originalText;
        // After a successful add, return to size pills so the next hover starts fresh.
        if (success) resetSelection(overlay);
      }, success ? 1400 : 1800);
    };

    if ($) {
      $("body").one("afterAddItem.ajaxCart", function() {
        done(true);
        setTimeout(function() {
          // Trigger the post-animation hook manually so the existing handler
          // (theme.js) runs and opens the cart drawer.
          $("body").trigger("afterButtonAnimation.ajaxCart", [null, true]);
        }, 350);
      });
      $("body").one("ajaxError.ajaxCart afterCartLoadFail.ajaxCart", function() {
        done(false);
      });
    } else {
      setTimeout(function() { done(true); }, 1200);
    }

    if (typeof form.requestSubmit === "function") {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  function handlePillClick(overlay, pill) {
    if (pill.disabled) return;
    // Primary: use the variant id refreshPillState set on this pill for the
    // current color. If that's missing (e.g. variant map mismatch on case),
    // fall back to scanning the variant map for the first available variant
    // with this size.
    var variantId = pill.dataset.variantId;
    if (!variantId) {
      var size = (pill.dataset.size || "").toLowerCase();
      var variants = readVariantMap(overlay);
      var fallback = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if ((v.size || "").toLowerCase() === size) {
          if (v.available) { fallback = v; break; }
          if (!fallback) fallback = v;
        }
      }
      if (fallback) {
        variantId = String(fallback.id);
        pill.dataset.variantId = variantId;
      }
    }
    if (!variantId) return;
    // Direct add (1-click) — the 2-step confirm UI is only used when the
    // sidebar pre-selects a size on page load.
    submitFromPill(overlay, pill, variantId);
  }

  function submitFromPill(overlay, pill, variantId) {
    var form = overlay.querySelector(".js-product-form");
    if (!form) return;
    var idInput = form.querySelector(".js-quick-add-id");
    if (idInput) idInput.value = variantId;
    syncFinalSaleProperty(overlay, variantId);

    var originalLabel = pill.textContent;
    pill.classList.remove("is-added", "is-error");
    pill.classList.add("is-loading");
    pill.textContent = "...";

    var $ = window.jQuery;
    var done = function(success) {
      pill.classList.remove("is-loading");
      pill.textContent = originalLabel;
      if (success) {
        pill.classList.add("is-added");
        overlay.classList.remove("is-open");
        var trigger = overlay.parentElement && overlay.parentElement.querySelector(".js-quick-add-mobile-trigger");
        if (trigger) trigger.setAttribute("aria-expanded", "false");
        setTimeout(function() { pill.classList.remove("is-added"); }, 1400);
      } else {
        pill.classList.add("is-error");
        setTimeout(function() { pill.classList.remove("is-error"); }, 1800);
      }
    };

    if ($) {
      $("body").one("afterAddItem.ajaxCart", function() {
        done(true);
        setTimeout(function() {
          $("body").trigger("afterButtonAnimation.ajaxCart", [null, true]);
        }, 350);
      });
      $("body").one("ajaxError.ajaxCart afterCartLoadFail.ajaxCart", function() {
        done(false);
      });
    } else {
      setTimeout(function() { done(true); }, 1200);
    }

    if (typeof form.requestSubmit === "function") form.requestSubmit();
    else form.submit();
  }

  // Active size filter values, tried in this order:
  //   1. Server-rendered JSON script tag (#js-collection-active-sizes).
  //   2. The active filter chips in the DOM (annotated with
  //      data-filter-label/data-filter-value). Most reliable on collection
  //      and search pages because it reads exactly what Liquid rendered.
  //   3. URL params (?filter.v.option.size=Small etc.) — last-resort fallback.
  function getActiveSidebarSizes() {
    var sizes = [];

    // 1. Script tag
    var node = document.getElementById("js-collection-active-sizes");
    if (node && node.textContent && node.textContent.trim()) {
      try {
        var arr = JSON.parse(node.textContent);
        if (Array.isArray(arr)) {
          arr.forEach(function(s) {
            if (s) sizes.push(String(s).toLowerCase());
          });
        }
      } catch (e) { /* ignore parse errors */ }
    }
    if (sizes.length) return sizes;

    // 2. Active filter chips
    var chips = $$(".js-active-filter-chip");
    chips.forEach(function(chip) {
      var label = (chip.getAttribute("data-filter-label") || "").toLowerCase();
      var value = (chip.getAttribute("data-filter-value") || "").toLowerCase();
      if (label.indexOf("size") !== -1 && value) sizes.push(value);
    });
    if (sizes.length) return sizes;

    // 3. URL params
    try {
      var params = new URLSearchParams(window.location.search);
      params.forEach(function(value, key) {
        var k = key.toLowerCase();
        if (k.indexOf("filter.") === 0 && k.indexOf("size") !== -1) {
          if (value) sizes.push(value.toLowerCase());
        }
      });
    } catch (e) { /* ignore */ }
    return sizes;
  }

  function autoSelectFromSidebar(overlay, activeSizes) {
    if (!activeSizes.length) return;
    // Find the first matching pill that's available for the current color.
    var pills = $$(".js-quick-add-pill", overlay);
    for (var i = 0; i < pills.length; i++) {
      var pill = pills[i];
      if (pill.disabled) continue;
      var size = (pill.dataset.size || "").toLowerCase();
      if (activeSizes.indexOf(size) !== -1) {
        showConfirm(overlay, pill);
        return;
      }
    }
  }

  // Shopify's storefront size filter shows products that HAVE the size as a
  // variant — it doesn't check inventory, so sold-out-in-that-size products
  // still appear. Hide the grid cell for those.
  function hideIfNoStockForActiveSize(overlay, activeSizes) {
    if (!activeSizes.length) return;
    var variants = readVariantMap(overlay);
    if (!variants.length) return;
    var hasAvailable = false;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var size = (v.size || "").toLowerCase();
      if (v.available && activeSizes.indexOf(size) !== -1) {
        hasAvailable = true;
        break;
      }
    }
    if (hasAvailable) return;
    var cell = overlay.closest(".o-layout__item") || overlay.closest(".product-card");
    if (cell) {
      cell.classList.add("is-out-of-stock-for-size");
      cell.style.display = "none";
    }
  }

  // Wire a single overlay. Idempotent — guards via a flag so re-running on
  // ajax-reloaded sections doesn't double-bind clicks.
  function initOverlay(overlay, activeSidebarSizes) {
    if (overlay.__quickAddWired) {
      // Already wired; just re-apply auto-select in case filter changed.
      refreshPillState(overlay);
      resetSelection(overlay);
      autoSelectFromSidebar(overlay, activeSidebarSizes);
      hideIfNoStockForActiveSize(overlay, activeSidebarSizes);
      return;
    }
    overlay.__quickAddWired = true;

    refreshPillState(overlay);
    ensureConfirmUI(overlay);
    autoSelectFromSidebar(overlay, activeSidebarSizes);
    hideIfNoStockForActiveSize(overlay, activeSidebarSizes);

    $$(".js-quick-add-pill", overlay).forEach(function(pill) {
      pill.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        handlePillClick(overlay, pill);
      });
    });

    overlay.addEventListener("click", function(e) {
      var confirmBtn = closestFrom(e.target, ".js-quick-add-confirm-btn");
      if (confirmBtn) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = overlay.dataset.selectedVariantId;
        if (!variantId) return;
        submitAdd(overlay, variantId, confirmBtn);
        return;
      }
      var change = closestFrom(e.target, ".js-quick-add-change");
      if (change) {
        e.preventDefault();
        e.stopPropagation();
        resetSelection(overlay);
        return;
      }
    });

    var addBtn = overlay.querySelector(".js-quick-add-submit");
    if (addBtn) wireSubmitBtn(overlay, addBtn);

    var mobileTrigger = overlay.parentElement && overlay.parentElement.querySelector(".js-quick-add-mobile-trigger");
    if (mobileTrigger) {
      mobileTrigger.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        var willOpen = !overlay.classList.contains("is-open");
        $$(".js-quick-add-overlay.is-open").forEach(function(other) {
          if (other === overlay) return;
          other.classList.remove("is-open");
          var otherTrigger = other.parentElement && other.parentElement.querySelector(".js-quick-add-mobile-trigger");
          setTriggerState(otherTrigger, false);
        });
        overlay.classList.toggle("is-open", willOpen);
        setTriggerState(mobileTrigger, willOpen);
      });
    }
  }

  function wireSubmitBtn(overlay, addBtn) {
    addBtn.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      var form = overlay.querySelector(".js-product-form");
      if (!form) return;
      var originalLabel = addBtn.textContent;
      addBtn.classList.remove("is-added", "is-error");
      addBtn.classList.add("is-loading");
      addBtn.textContent = "Adding…";

      var $ = window.jQuery;
      var done = function(success) {
        addBtn.classList.remove("is-loading");
        addBtn.textContent = success ? "Added ✓" : "Try again";
        addBtn.classList.add(success ? "is-added" : "is-error");
        setTimeout(function() {
          addBtn.classList.remove("is-added", "is-error");
          addBtn.textContent = originalLabel;
        }, success ? 1400 : 1800);
      };
      if ($) {
        $("body").one("afterAddItem.ajaxCart", function() {
          done(true);
          setTimeout(function() {
            $("body").trigger("afterButtonAnimation.ajaxCart", [null, true]);
          }, 350);
        });
        $("body").one("ajaxError.ajaxCart afterCartLoadFail.ajaxCart", function() {
          done(false);
        });
      } else {
        setTimeout(function() { done(true); }, 1200);
      }

      if (typeof form.requestSubmit === "function") form.requestSubmit();
      else form.submit();
    });
  }

  function init() {
    var overlays = $$(".js-quick-add-overlay");
    var activeSidebarSizes = getActiveSidebarSizes();
    overlays.forEach(function(overlay) {
      initOverlay(overlay, activeSidebarSizes);
    });

    // Re-init when ajax-loaded sections add overlays later (filter changes,
    // pagination, infinite scroll). Idempotent on already-wired overlays.
    var mo = new MutationObserver(function(mutations) {
      var sizes = null;
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(n) {
          if (n.nodeType !== 1) return;
          var candidates = [];
          if (n.classList && n.classList.contains("js-quick-add-overlay")) candidates.push(n);
          if (n.querySelectorAll) {
            n.querySelectorAll(".js-quick-add-overlay").forEach(function(o) { candidates.push(o); });
          }
          if (candidates.length) {
            if (sizes === null) sizes = getActiveSidebarSizes();
            candidates.forEach(function(o) { initOverlay(o, sizes); });
          }
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });

    // Color sync: when the user clicks a color swatch on the card, the
    // existing ProductCardSwatches handler swaps the image. We piggyback on
    // the same click — find which card the swatch belongs to, then update
    // that card's overlay current-color from the swatch's aria-label.
    document.addEventListener("click", function(e) {
      var swatchItem = closestFrom(e.target, ".js-product-swatch-item");
      if (!swatchItem) return;
      var card = swatchItem.closest(".js-product-card");
      if (!card) return;
      var overlay = card.querySelector(".js-quick-add-overlay");
      if (!overlay) return;
      var swatch = swatchItem.querySelector("variant-swatch");
      var label = swatch && swatch.getAttribute("aria-label");
      if (label) setCurrentColor(overlay, label);
    }, true);

    document.addEventListener("click", function(e) {
      $$(".js-quick-add-overlay.is-open").forEach(function(overlay) {
        var card = overlay.closest(".product-card");
        if (card && card.contains(e.target)) return;
        overlay.classList.remove("is-open");
        var trigger = overlay.parentElement && overlay.parentElement.querySelector(".js-quick-add-mobile-trigger");
        setTriggerState(trigger, false);
      });
    });

    document.addEventListener("keydown", function(e) {
      if (e.key !== "Escape") return;
      $$(".js-quick-add-overlay.is-open").forEach(function(overlay) {
        overlay.classList.remove("is-open");
        var trigger = overlay.parentElement && overlay.parentElement.querySelector(".js-quick-add-mobile-trigger");
        setTriggerState(trigger, false);
        if (trigger) trigger.focus();
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();


/* ==== rb-combined-listing-fix.js ==== */
;/**
 * rb-combined-listing-fix.js
 *
 * FIXES: "Unavailable" add-to-cart button on every combined-listing product
 * (Zach, Marcus, Blanket Shirts, ...).
 *
 * Cause
 * -----
 * Shopify's native Combined Listings adds an EXTRA option to the storefront
 * product object — so `product.options` reads ["Color", "Color", "Size"] and
 * every variant carries three option values. The theme's variant picker only
 * renders the options it knows about (Color + Size = two <fieldset>s), so when
 * VariantRadios matches the selected values against the variant list it
 * compares 2 values to 3-value variants, finds nothing, treats the variant as
 * null, and disables the button with theme.t.unavailable.
 *
 * Verified live 26 Aug: style-zach, style-marcus,
 * blanket-shirt-shades-of-dusk-plaid, blanket-shirt-grassland-salton-plaid all
 * report 3 storefront options vs 2 rendered fieldsets.
 *
 * Fix
 * ---
 * Only on products where that mismatch exists, resolve the variant ourselves by
 * VALUE CONTAINMENT (a variant matches when it contains every selected value,
 * regardless of option position) and then re-assert the correct button state +
 * hidden variant id. A MutationObserver re-applies it if the theme's own
 * picker stomps the label afterwards.
 *
 * Deliberately inert on normal products — if options and fieldsets agree, this
 * script does nothing at all.
 */
(function () {
  'use strict';

  var form, picker, addBtn, productData, active = false;
  var reapplyTimer = null;

  function labelEl() {
    return (addBtn && addBtn.querySelector('.js-product-add-text')) || addBtn;
  }

  function t(key, fallback) {
    try {
      if (window.theme && window.theme.t && window.theme.t[key]) return window.theme.t[key];
    } catch (e) {}
    return fallback;
  }

  /** Values currently selected in the rendered fieldsets. */
  function selectedValues() {
    if (!picker) return [];
    var vals = [];
    picker.querySelectorAll('fieldset').forEach(function (fs) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) { vals.push(checked.value); return; }
      var select = fs.querySelector('select');
      if (select && select.value) vals.push(select.value);
    });
    if (!vals.length) {
      var sel = picker.querySelector('select[name="options[]"], select');
      if (sel && sel.value) vals.push(sel.value);
    }
    return vals;
  }

  /**
   * Match by containment rather than position: a variant is the one the
   * shopper picked when every selected value appears in its option list.
   * Handles the duplicated Color option without caring which position the
   * combined-listing option landed in.
   */
  function resolveVariant(values) {
    if (!productData || !values.length) return null;
    var exact = null;
    for (var i = 0; i < productData.variants.length; i++) {
      var v = productData.variants[i];
      var opts = v.options || [];
      var all = true;
      for (var j = 0; j < values.length; j++) {
        if (opts.indexOf(values[j]) === -1) { all = false; break; }
      }
      if (all) {
        // Prefer an available match; otherwise keep the first match.
        if (v.available) return v;
        if (!exact) exact = v;
      }
    }
    return exact;
  }

  function applyState() {
    if (!active || !addBtn) return;

    var variant = resolveVariant(selectedValues());
    if (!variant) return; // nothing better to say than what the theme shows

    var idInput = form.querySelector('input[name="id"]');
    if (idInput && String(idInput.value) !== String(variant.id)) {
      idInput.value = variant.id;
    }

    var lab = labelEl();

    if (variant.available) {
      // IMPORTANT: when the theme can't resolve the variant, pdp-back-in-stock.js
      // sees a null/sold-out variant and flips the button to "Notify me when
      // back" — on sizes that are actually IN STOCK (observed live on
      // style-zach 29x32). So we must override BIS mode here, not defer to it.
      var want = t('add_to_cart', 'Add to cart');
      if (lab && lab.textContent.trim() !== want) lab.textContent = want;
      if (addBtn.classList.contains('is-bis-mode')) {
        addBtn.classList.remove('is-bis-mode');
        addBtn.setAttribute('type', 'submit');
      }
      if (addBtn.hasAttribute('disabled')) addBtn.removeAttribute('disabled');
      addBtn.classList.remove('is-disabled');
      var wrap = addBtn.closest('.js-product-buttons');
      if (wrap) wrap.classList.remove('is-disabled');
      return;
    }

    // Genuinely sold out: hand the label back to pdp-back-in-stock.js so the
    // notify flow keeps working.
    if (addBtn.classList.contains('is-bis-mode')) return;
    var soldOut = t('sold_out', 'Sold out');
    if (lab && lab.textContent.trim() !== soldOut) lab.textContent = soldOut;
  }

  /* ------------------------------------------------ sold-out size marking */

  /**
   * Cross out option values with no stock, using the theme's own
   * `.is-disabled` class (its diagonal-strike CSS is already global — verified
   * on blanket-shirt-seabreeze-mojave-stripe, where X-Large and XX-Large strike
   * correctly).
   *
   * ONLY runs on combined-listing products. Normal products already mark
   * themselves correctly and are left completely alone; the extra storefront
   * option is what stops the theme's own matching from marking these.
   *
   * A fieldset is only marked when every one of its values actually appears in
   * this product's variants. That skips the combined-listing colour row, whose
   * values belong to sibling products and would otherwise all read as sold out.
   */
  function markSoldOut() {
    if (!active) return; // normal products: the theme handles this itself
    if (!productData || !picker) return;
    var variants = productData.variants || [];
    if (!variants.length) return;

    var fieldsets = [].slice.call(picker.querySelectorAll('fieldset'));

    function valuePresent(val) {
      for (var i = 0; i < variants.length; i++) {
        if ((variants[i].options || []).indexOf(val) !== -1) return true;
      }
      return false;
    }

    // Selected values we can safely hold fixed while testing another option.
    var held = [];
    fieldsets.forEach(function (fs) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      var val = checked ? checked.value : null;
      if (val && valuePresent(val)) held.push({ fs: fs, value: val });
    });

    fieldsets.forEach(function (fs) {
      var inputs = [].slice.call(fs.querySelectorAll('input[type="radio"]'));
      if (!inputs.length) return;

      var allPresent = inputs.every(function (i) { return valuePresent(i.value); });
      if (!allPresent) return; // combined-listing colour row — leave alone

      var others = held.filter(function (h) { return h.fs !== fs; })
                       .map(function (h) { return h.value; });

      inputs.forEach(function (input) {
        var combo = others.concat([input.value]);
        var inStock = variants.some(function (v) {
          if (!v.available) return false;
          var opts = v.options || [];
          return combo.every(function (c) { return opts.indexOf(c) !== -1; });
        });

        var label = fs.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]')
                 || (input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL' ? input.nextElementSibling : null);
        if (!label) return;

        // Stays clickable on purpose — selecting a sold-out size is how the
        // shopper reaches the back-in-stock notify flow.
        label.classList.toggle('is-disabled', !inStock);
        if (!inStock) label.setAttribute('data-rb-sold-out', 'true');
        else label.removeAttribute('data-rb-sold-out');
      });
    });
  }

  function scheduleApply() {
    if (reapplyTimer) clearTimeout(reapplyTimer);
    reapplyTimer = setTimeout(function () {
      if (active) applyState();
      markSoldOut();
    }, 60);
  }

  function detectMismatch() {
    if (!productData || !picker) return false;
    var optionCount = (productData.options || []).length;
    var fieldsets = picker.querySelectorAll('fieldset').length;
    var names = (productData.options || []).map(function (o) {
      return typeof o === 'string' ? o : o.name;
    });
    var hasDuplicateName = names.length !== names.filter(function (n, i) {
      return names.indexOf(n) === i;
    }).length;
    // Only engage where the picker genuinely can't express the variant.
    return (fieldsets > 0 && optionCount > fieldsets) || hasDuplicateName;
  }

  function init() {
    form = document.querySelector('form.product-form');
    if (!form) return;
    picker = document.querySelector('variant-radios, variant-selects');
    if (!picker) return;
    addBtn = form.querySelector('.product-form__cart-submit') || form.querySelector('[name="add"]');
    if (!addBtn) return;

    var handleMeta = document.querySelector('[data-pdp-bis-config]');
    var handle = null;
    if (handleMeta) {
      try { handle = JSON.parse(handleMeta.textContent).product_handle; } catch (e) {}
    }
    if (!handle) {
      var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
      handle = m && m[1];
    }
    if (!handle) return;

    var ready = window.__rsr_product_data
      ? Promise.resolve(window.__rsr_product_data)
      : fetch('/products/' + handle + '.js').then(function (r) { return r.json(); });

    ready.then(function (data) {
      productData = data;
      window.__rsr_product_data = window.__rsr_product_data || data;

      if (!detectMismatch()) return; // normal product — leave everything alone
      active = true;

      applyState();
      markSoldOut();
      picker.addEventListener('change', scheduleApply);

      // The theme's picker re-runs after ours and can restore "Unavailable";
      // watch the button and re-assert.
      var mo = new MutationObserver(scheduleApply);
      mo.observe(addBtn, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    }).catch(function () { /* leave the theme's behaviour untouched */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ==== rb-cart-mobile.js ==== */
;/**
 * rb-cart-mobile.js — mobile cart drawer (final spec, 26 Aug).
 *
 * 1. Swipe a row left to reveal Remove; tap the panel to remove.
 * 2. Remove stays a visible labelled button for anyone who doesn't swipe.
 * 3. Undo toast (5s) restoring variant + quantity + line properties.
 * 4. Quantity minus clamped at 1 so removal is never a hidden step-to-zero.
 * 5. Keeps recommendations below items in the scrolling area so they do not
 *    reserve space above the checkout footer on short mobile screens.
 */
(function () {
  'use strict';

  var MOBILE = 768;
  var UNDO_MS = 5000;
  var SWIPE_OPEN = 45;   // px left-drag to reveal
  var SWIPE_SHUT = 25;   // px right-drag to close
  var SWIPE_VTOL = 30;   // vertical slop before we treat it as a scroll

  var lastRemoved = null;
  var undoEl = null;
  var undoTimer = null;
  var cartCache = null;

  function isMobile() { return window.innerWidth < MOBILE; }
  function container() { return document.getElementById('CartContainer'); }

  /* ------------------------------------------------------------ cart data */

  function refreshCartCache() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartCache = cart; return cart; })
      .catch(function () { return null; });
  }

  function lineDataFor(lineIndex) {
    if (!cartCache || !cartCache.items) return null;
    var item = cartCache.items[lineIndex - 1]; // ajaxCart lines are 1-based
    if (!item) return null;

    var props = {};
    if (item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        if (item.properties[k] !== null && item.properties[k] !== '') props[k] = item.properties[k];
      });
    }
    var variantLabel = item.variant_title && item.variant_title !== 'Default Title'
      ? ' · ' + item.variant_title
      : '';
    return {
      id: item.variant_id,
      quantity: item.quantity,
      properties: props,
      selling_plan: item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.id : null,
      label: item.product_title + variantLabel
    };
  }

  /* -------------------------------------------------------------- undo UI */

  function ensureUndoEl() {
    if (undoEl && document.body.contains(undoEl)) return undoEl;
    undoEl = document.createElement('div');
    undoEl.className = 'rb-cart-undo';
    undoEl.setAttribute('role', 'status');
    undoEl.innerHTML =
      '<span class="rb-cart-undo__text"></span>' +
      '<button type="button" class="rb-cart-undo__btn">Undo</button>';
    undoEl.querySelector('.rb-cart-undo__btn').addEventListener('click', doUndo);
    document.body.appendChild(undoEl);
    return undoEl;
  }

  function showUndo(data) {
    if (!data) return;
    lastRemoved = data;
    var el = ensureUndoEl();
    el.querySelector('.rb-cart-undo__text').textContent = 'Removed ' + data.label;
    el.classList.add('is-visible');
    clearTimeout(undoTimer);
    undoTimer = setTimeout(hideUndo, UNDO_MS);
  }

  function hideUndo() {
    if (undoEl) undoEl.classList.remove('is-visible');
    lastRemoved = null;
  }

  function doUndo() {
    if (!lastRemoved) return hideUndo();

    var payload = {
      id: lastRemoved.id,
      quantity: lastRemoved.quantity,
      properties: lastRemoved.properties
    };
    if (lastRemoved.selling_plan) payload.selling_plan = lastRemoved.selling_plan;

    var btn = undoEl && undoEl.querySelector('.rb-cart-undo__btn');
    if (btn) btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function () { return refreshCartCache(); })
      .then(function () {
        if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
          window.ajaxCart.load();
        } else {
          window.location.reload();
        }
      })
      .catch(function () {})
      .then(function () {
        if (btn) btn.disabled = false;
        hideUndo();
      });
  }

  /* --------------------------------------------------------- enhancements */

  // Class toggle on an existing button. Adds nothing, moves nothing.
  function clampMinus(root) {
    var rows = root.querySelectorAll('.ajaxcart__row');
    [].forEach.call(rows, function (row) {
      var input = row.querySelector('.ajaxcart__qty-num');
      var minus = row.querySelector('.ajaxcart__qty--minus');
      if (!input || !minus) return;
      var qty = parseInt(String(input.value).replace(/\D/g, ''), 10) || 1;
      minus.classList.toggle('rb-qty-floor', qty <= 1);
      if (qty <= 1) minus.setAttribute('aria-disabled', 'true');
      else minus.removeAttribute('aria-disabled');
    });
  }

  /**
   * "Sage / Sage / Large" → "Sage / Large".
   *
   * Combined listings add a duplicate option to the storefront product, so the
   * variant title repeats the colour. It's cosmetic, but it's the line the
   * shopper reads to confirm what they're buying, so it shouldn't look broken.
   * Only collapses ADJACENT identical segments — a genuine "Black / Black"
   * two-tone stays intact only if the values differ, which is the correct read.
   */
  function tidyVariantText(root) {
    var metas = root.querySelectorAll('.ajaxcart__product-meta');
    [].forEach.call(metas, function (el) {
      if (el.dataset.rbTidied === '1') return;
      var raw = el.textContent.trim();
      if (raw.indexOf('/') === -1) return;

      var parts = raw.split('/').map(function (p) { return p.trim(); }).filter(Boolean);
      var out = [];
      parts.forEach(function (p) {
        if (!out.length || out[out.length - 1].toLowerCase() !== p.toLowerCase()) out.push(p);
      });
      if (out.length !== parts.length) el.textContent = out.join(' / ');
      el.dataset.rbTidied = '1';
    });
  }

  /**
   * Lift the line price up next to the product name (Huckberry-style), so the
   * row reads: thumb | name … price / variant / controls — instead of leaving
   * the price stranded on the controls line.
   *
   * Skipped on discounted lines: those render an original price, a discount
   * note and a sale price together, and that group belongs in its own column.
   */
  function inlinePrice(root) {
    var rows = root.querySelectorAll('.ajaxcart__row');
    [].forEach.call(rows, function (row) {
      if (row.querySelector('.rb-price-inline')) return;           // already moved
      if (row.querySelector('.ajaxcart-item__discount')) return;   // leave discounts alone

      var prices = row.querySelectorAll('.ajaxcart-item__price');
      if (prices.length !== 1) return;                             // unit price etc. — leave alone

      var price = prices[0];
      var top = row.querySelector('.ajaxcart__product-top');
      if (!top) return;
      var cols = top.querySelectorAll('.o-layout__item');
      var textCol = cols[cols.length - 1];
      if (!textCol || textCol.contains(price)) return;

      var nameLink = textCol.querySelector('.ajaxcart__product-name');
      var anchor = nameLink ? (nameLink.closest('a') || nameLink) : null;

      price.classList.add('rb-price-inline');
      if (anchor && anchor.parentNode === textCol) {
        textCol.insertBefore(price, anchor.nextSibling);
      } else {
        textCol.insertBefore(price, textCol.firstChild);
      }
    });
  }

  /**
   * The rail's add control keeps its "+" glyph — the CSS turns it into a small
   * round button on the image corner. (An earlier pass relabelled it "Add",
   * which needed a full-width button row and made the strip heavy.) The rail's
   * own script swaps this text to "…" while adding, so leave it alone.
   */

  function enhance() {
    if (!isMobile()) return;
    var root = container();
    if (!root) return;
    clampMinus(root);
    tidyVariantText(root);
    inlinePrice(root);
    // Recommendations remain after items inside the scroller.
  }

  /* ---------------------------------------------------------------- swipe */

  function closeAllSwiped(except) {
    var open = document.querySelectorAll('.ajaxcart__product.rb-swiped');
    [].forEach.call(open, function (p) { if (p !== except) p.classList.remove('rb-swiped'); });
  }

  function bindSwipe() {
    var startX = null, startY = null, row = null;

    document.addEventListener('pointerdown', function (e) {
      if (!isMobile()) return;
      row = e.target.closest ? e.target.closest('.ajaxcart__product') : null;
      startX = e.clientX;
      startY = e.clientY;
    }, { passive: true });

    document.addEventListener('pointerup', function (e) {
      if (!isMobile() || !row || startX === null) { row = null; startX = null; return; }
      var dx = e.clientX - startX;
      var dy = Math.abs(e.clientY - startY);
      if (dy < SWIPE_VTOL) {
        if (dx < -SWIPE_OPEN) {
          closeAllSwiped(row);
          row.classList.add('rb-swiped');
        } else if (dx > SWIPE_SHUT) {
          row.classList.remove('rb-swiped');
        }
      }
      row = null; startX = null; startY = null;
    }, { passive: true });
  }

  /* --------------------------------------------------------------- events */

  function onDocClick(e) {
    if (!isMobile()) return;

    // Tap the revealed red panel → run the theme's own remove.
    //
    // The panel is a ::before on .ajaxcart__product and the face
    // (.ajaxcart__row) is translated off it, so a tap on the exposed strip
    // lands on the product element itself — never inside the row. Testing
    // ancestry rather than coordinates keeps this correct at any width, and
    // means the forwarded click below re-enters through the row branch instead
    // of looping back into this one.
    var swiped = e.target.closest && e.target.closest('.ajaxcart__product.rb-swiped');
    if (swiped && !(e.target.closest && e.target.closest('.ajaxcart__row'))) {
      var panelBtn = swiped.querySelector('.ajaxcart__remove');
      if (panelBtn) {
        e.preventDefault();
        e.stopPropagation();
        panelBtn.click();
        return;
      }
    }

    // Capture the line BEFORE ajaxCart mutates the cart, so Undo can rebuild it.
    var removeBtn = e.target.closest && e.target.closest('.ajaxcart__remove');
    if (removeBtn) {
      var line = parseInt(removeBtn.getAttribute('data-line'), 10);
      var data = lineDataFor(line);
      if (data) setTimeout(function () { showUndo(data); }, 500);
    }
  }

  function init() {
    refreshCartCache();
    document.addEventListener('click', onDocClick, true);
    bindSwipe();

    var root = container();
    if (root) {
      // ajaxCart re-renders the container on every cart change, and the rail
      // injects itself asynchronously — re-apply on both.
      // 2026-09-07: debounced, and ignores mutations that come from the recommendation
      // rail or Judge.me badges hydrating — those fired refreshCartCache() dozens of
      // times per page load (15 GET /cart.js on the homepage alone).
      var pending = null;
      new MutationObserver(function (mutations) {
        var relevant = false;
        for (var i = 0; i < mutations.length; i++) {
          var t = mutations[i].target;
          if (t && t.closest && (t.closest('.rb-cart-rail') || t.closest('.jdgm-prev-badge'))) continue;
          relevant = true; break;
        }
        if (!relevant) return;
        if (pending) clearTimeout(pending);
        pending = setTimeout(function () {
          pending = null;
          enhance();
          refreshCartCache();
        }, 250);
      }).observe(root, { childList: true, subtree: true });
    }

    window.addEventListener('resize', enhance);
    enhance();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ==== rb-review-count.js ==== */
;/**
 * rb-review-count.js
 *
 * Product cards were showing "1 review" instead of "(1)" on mobile.
 *
 * Cause: `product.metafields.judgeme.badge` renders the badge server-side with
 * Judge.me's default wording ("1 review" / "3 reviews"). Judge.me's own script
 * later rewrites that text to the configured "(n)" format — on desktop it lands
 * before you notice, on mobile it's often visibly late or doesn't run at all.
 *
 * Fix: set the text ourselves from the badge's own `data-number-of-reviews`,
 * immediately and again whenever grids re-render (filters, pagination, quick
 * add). Idempotent — if Judge.me already wrote "(n)" this changes nothing.
 */
(function () {
  'use strict';

  var SEL = '.jdgm-prev-badge';

  function normalize(badge) {
    if (!badge) return;
    var textEl = badge.querySelector('.jdgm-prev-badge__text');
    if (!textEl) return;

    var n = badge.getAttribute('data-number-of-reviews');
    if (n === null || n === '') return;

    var count = parseInt(n, 10);
    if (isNaN(count)) return;

    // Judge.me hides the whole badge for zero-review products; respect that.
    if (count <= 0) return;

    var want = '(' + count + ')';
    if (textEl.textContent.trim() !== want) textEl.textContent = want;
  }

  function run(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var badges = scope.querySelectorAll(SEL);
    [].forEach.call(badges, normalize);
  }

  function init() {
    run(document);

    // Grids re-render on filter/pagination, and Judge.me hydrates async —
    // catch both without re-scanning the whole document every time.
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'characterData') {
          var host = m.target.parentElement && m.target.parentElement.closest
            ? m.target.parentElement.closest(SEL)
            : null;
          if (host) normalize(host);
          continue;
        }
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(SEL)) normalize(node);
          else run(node);
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    // Judge.me can hydrate after load; a couple of cheap re-runs cover it.
    setTimeout(function () { run(document); }, 1200);
    setTimeout(function () { run(document); }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ==== swatch-hover-preview.js ==== */
;/*
 * Swatch hover-preview.
 *
 * Existing ProductCardSwatches (in theme.js) swaps the card image when a
 * color swatch is CLICKED. This adds the parallel hover behavior:
 *   - mouseenter on a swatch → temporarily swap the card image to that
 *     variant's photo (preview)
 *   - mouseleave on the swatch (mouse moves elsewhere on the card or off) →
 *     revert the image to whatever was showing before the preview started
 *
 * Click still locks the selection through the existing class handler. We do
 * not touch the variant URL or the .js-active state — those are click-only.
 *
 * We need to play nicely when the user moves directly from one swatch to
 * another: that's a mouseenter on B without a meaningful mouseleave (the
 * leave from A fires too, but B's enter wins). We just take the latest enter
 * as the current preview, and only revert when the mouse leaves the WHOLE
 * swatches row.
 */
(function () {
  "use strict";

  function readCurrentImageState(img) {
    if (!img) return null;
    return {
      src: img.getAttribute("src"),
      srcset: img.getAttribute("srcset"),
      width: img.getAttribute("width"),
      height: img.getAttribute("height"),
    };
  }

  function applyImageState(img, state) {
    if (!img || !state) return;
    if (state.src != null) img.setAttribute("src", state.src);
    if (state.srcset != null) img.setAttribute("srcset", state.srcset);
    if (state.width != null) img.setAttribute("width", state.width);
    if (state.height != null) img.setAttribute("height", state.height);
  }

  function previewSwatch(card, swatchItem) {
    var img = card.querySelector(".js-img-grid");
    if (!img) return;

    var template = swatchItem.dataset.variantImage;
    var w = parseInt(swatchItem.dataset.variantImageWidth || "0", 10);
    var h = parseInt(swatchItem.dataset.variantImageHeight || "0", 10);
    if (!template || !w || !h) return;

    // Remember the state we started from so we can revert. Only capture on
    // the FIRST hover within a hover session — subsequent swatch-to-swatch
    // moves shouldn't overwrite the original.
    if (!card._previewBackup) {
      card._previewBackup = readCurrentImageState(img);
    }

    var src = template.replace("{width}", "300");
    var srcsetWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512];
    var srcset = srcsetWidths.reduce(function (acc, sw) {
      var sh = Math.floor((sw / w) * h);
      return acc + template.replace("{width}", String(sw)) + " " + sw + "w " + sh + "h, ";
    }, "");
    var height = Math.floor((300 / w) * h);

    img.setAttribute("src", src);
    img.setAttribute("srcset", srcset);
    img.setAttribute("width", "300");
    img.setAttribute("height", String(height));
  }

  function revertPreview(card) {
    if (!card._previewBackup) return;
    var img = card.querySelector(".js-img-grid");
    applyImageState(img, card._previewBackup);
    card._previewBackup = null;
  }

  function init() {
    document.addEventListener("mouseover", function (e) {
      var item = e.target.closest && e.target.closest(".js-product-swatch-item");
      if (!item) return;
      var card = item.closest(".js-product-card");
      if (!card) return;
      previewSwatch(card, item);
    });

    // Revert when the mouse leaves the swatches row entirely. Using mouseout
    // on the row container is more reliable than per-item mouseleave when
    // pills are tightly packed.
    document.addEventListener("mouseout", function (e) {
      var row = e.target.closest && e.target.closest("product-card-swatches, .product-card__swatch");
      if (!row) return;
      // relatedTarget is the element the mouse is moving INTO. If it's still
      // inside the row, ignore — we're just crossing internal boundaries.
      var to = e.relatedTarget;
      if (to && row.contains(to)) return;
      var card = row.closest(".js-product-card");
      if (!card) return;
      // If the user has CLICKED a swatch (the existing .js-active gets set
      // by theme.js), don't revert past their selection — clear our backup
      // so the next preview captures fresh state from the active swatch.
      var activeNow = card.querySelector(".js-product-swatch-item.js-active");
      if (activeNow) {
        card._previewBackup = null;
        return;
      }
      revertPreview(card);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();


/* ==== custom.js ==== */
;/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* ==========================================================================
   SEARCH SCOPE — include pages and articles in site search
   Added 2026-09-03. Self-contained block: delete it to revert.

   Problem: every search form hardcodes <input type="hidden" name="type"
   value="product">, so /search only ever searched products and pages/articles
   were invisible. Measured on live 2026-09-03:

     "size guide"  3 results -> 5 with pages+articles
     "returns"     5 results -> 7
     "flagstaff"   4 results -> 6   (a store location page nobody could find)

   There are four of those inputs, across layout/theme.liquid (the header
   drawer) and sections/main-search.liquid (the on-page form, the no-results
   form, the mobile form). The proper fix is to change the value in those two
   Liquid files. This lives here instead because those files are 28KB and 58KB
   and editing them through the Admin API means re-transmitting them in full —
   a far larger risk surface than 20 lines for a one-word change. Do it in
   Liquid next time either file is open, then delete this block.

   Caveat, plainly: this is JavaScript, so with JS off the forms still submit
   product-only. Predictive search is already JS-dependent so this adds no new
   failure mode, but it is a shim, not the real fix.
   ========================================================================== */
(function () {
  var SEARCH_TYPES = 'product,page,article';

  function widenSearchScope() {
    var inputs = document.querySelectorAll('form[action*="/search"] input[name="type"]');

    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value !== SEARCH_TYPES) {
        inputs[i].value = SEARCH_TYPES;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', widenSearchScope);
  } else {
    widenSearchScope();
  }

  /* Re-run on pageshow so a back/forward cache restore cannot serve a form
     that has reverted to its markup value. */
  window.addEventListener('pageshow', widenSearchScope);
})();

/* ==========================================================================
   Quick add tray (D2) + 7-or-more-size dropdown (E) + back-in-stock capture.
   2026-09-03. Approved mockup: rooster-notes/mockups/quick-add-variants-mockups.html rev 3.

   Why it lives in custom.js rather than its own asset: custom.js is already
   loaded globally with defer from layout/theme.liquid, so nothing there needs
   editing. Paired with Block 6 in assets/rooster-commerce.css. Those two files
   are the entire change — product-grid-item.liquid (60KB), quick-add-overlay.js
   and every mobile file are untouched, so a revert is two file writes.

   ARCHITECTURE, one sentence: the Liquid-rendered size pills are the model, the
   controls the shopper sees are ours. We hide `.quick-add-overlay__pills` and
   mirror it — as our own pills under 7 sizes, as a <select> at 7 or more.
   quick-add-overlay.js keeps sole ownership of resolving (colour x size) ->
   variant and of add-to-cart; we only read its pills' state and replay
   `pill.click()`, so the cart, ajaxCart, the drawer, the final-sale property
   and GA4 all run the existing, tested path.

   Verified 2026-09-03: adding Ambassador Slim Fit 30x32 from the dropdown put
   _final_sale:true and _fs_basis cap:18800|price:15800|src:quickadd on the
   cart line, same as a pill add.

   WHY WE RENDER OUR OWN PILLS INSTEAD OF USING THE THEME'S (2026-09-03, Mark:
   "if its sold out the menu still needs to come up so someone can request a
   notification"): a sold-out size must be CLICKABLE to reach the back-in-stock
   form. The theme's pills cannot be, because refreshPillState in
   quick-add-overlay.js sets `pill.disabled = true` on init and on every colour
   change, and a disabled button fires no click events. Un-disabling them would
   mean fighting that function forever, on the add-to-cart path, on a live
   store. Mirroring is the same pattern the dropdown already used and it leaves
   the theme's logic completely alone.

   MOBILE IS UNTOUCHED, deliberately (Mark: "dont touch mobile"). Below 768px
   rb-quick-add-sheet.js intercepts the trigger in the capture phase and the
   in-tile overlay never opens; every rule in Block 6 is scoped min-width 768px.
   The Klaviyo calls below are a deliberate DUPLICATE of the ones in
   rb-quick-add-sheet.js rather than a shared helper, because sharing would mean
   editing that file. Both read the same `.js-rb-qas-config` JSON, so the public
   key and list id still have exactly one source of truth. If the Klaviyo API
   shape ever changes, BOTH copies need the edit — that is the price of not
   touching mobile, and it is written here so the second copy is not a surprise.
   ====================================================================== */
(function () {
  'use strict';

  var SELECT_THRESHOLD = 7; // 7 or more sizes -> dropdown

  function pillsOf(overlay) {
    return Array.prototype.slice.call(overlay.querySelectorAll('.js-quick-add-pill'));
  }

  function config() {
    var node = document.querySelector('.js-rb-qas-config');
    if (!node) return {};
    try { return JSON.parse(node.textContent) || {}; } catch (e) { return {}; }
  }

  /* ------------------------------------------------------------ notify view */

  function buildNotify(overlay, tray) {
    var box = document.createElement('div');
    box.className = 'rb-qa-notify';
    box.innerHTML =
      '<p class="rb-qa-notify__txt"><b class="js-rb-qa-notify-size"></b> is sold out. ' +
        'Leave your email and we&rsquo;ll tell you the moment it&rsquo;s back.</p>' +
      '<div class="rb-qa-notify__row">' +
        '<input type="email" class="rb-qa-notify__email js-rb-qa-email" placeholder="you@email.com" ' +
          'inputmode="email" autocomplete="email" autocapitalize="off">' +
        '<button type="button" class="rb-qa-notify__go js-rb-qa-notify-go">Notify</button>' +
      '</div>' +
      '<p class="rb-qa-notify__msg rb-qa-notify__done">&#10003; You&rsquo;re on the list.</p>' +
      '<p class="rb-qa-notify__msg rb-qa-notify__err">Something went wrong &mdash; try again.</p>' +
      '<button type="button" class="rb-qa-notify__back js-rb-qa-notify-back">&larr; back to sizes</button>';
    tray.appendChild(box);

    box.querySelector('.js-rb-qa-notify-back').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      hideNotify(overlay);
    });
    box.querySelector('.js-rb-qa-notify-go').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      submitNotify(overlay);
    });
    box.querySelector('.js-rb-qa-email').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); submitNotify(overlay); }
    });
    return box;
  }

  function showNotify(overlay, size, variantId) {
    if (!variantId) return; // nothing to subscribe to
    overlay.dataset.rbNotifyVariant = String(variantId);
    var sizeEl = overlay.querySelector('.js-rb-qa-notify-size');
    if (sizeEl) sizeEl.textContent = size || 'This size';
    var email = overlay.querySelector('.js-rb-qa-email');
    if (email) email.value = '';
    overlay.classList.remove('rb-qa-notify-done', 'rb-qa-notify-err');
    overlay.classList.add('rb-qa-notify-mode');
    if (email) email.focus();
  }

  function hideNotify(overlay) {
    overlay.classList.remove('rb-qa-notify-mode', 'rb-qa-notify-done', 'rb-qa-notify-err');
    overlay.removeAttribute('data-rb-notify-variant');
  }

  /* Deliberate duplicate of rb-quick-add-sheet.js's Klaviyo calls — see the
     header. Same endpoints, same revision, same two-call shape: a back-in-stock
     subscription on the exact variant, plus the newsletter list if one is set. */
  function submitNotify(overlay) {
    var emailEl = overlay.querySelector('.js-rb-qa-email');
    var email = ((emailEl && emailEl.value) || '').trim();
    var variantId = overlay.dataset.rbNotifyVariant;
    overlay.classList.remove('rb-qa-notify-err', 'rb-qa-notify-done');

    if (!email || email.indexOf('@') < 1 || !variantId) {
      if (emailEl) emailEl.focus();
      return;
    }
    var cfg = config();
    if (!cfg.klaviyo_public_key) {
      overlay.classList.add('rb-qa-notify-err');
      return;
    }

    var btn = overlay.querySelector('.js-rb-qa-notify-go');
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    var key = encodeURIComponent(cfg.klaviyo_public_key);
    var jobs = [];

    jobs.push(fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + key, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: {
              data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId }
            }
          }
        }
      })
    }));

    if (cfg.newsletter_list_id) {
      jobs.push(fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + key, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } },
              custom_source: 'Quick add back-in-stock (desktop)'
            },
            relationships: { list: { data: { type: 'list', id: cfg.newsletter_list_id } } }
          }
        })
      }));
    }

    Promise.all(jobs)
      .then(function (responses) {
        if (responses.some(function (r) { return !r.ok; })) throw new Error('klaviyo');
        overlay.classList.add('rb-qa-notify-done');
        setTimeout(function () { hideNotify(overlay); }, 1600);
      })
      .catch(function () {
        overlay.classList.add('rb-qa-notify-err');
      })
      .then(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  }

  /* --------------------------------------------------------------- D: pills */

  function buildPills(overlay, tray, sizes) {
    var wrap = document.createElement('div');
    wrap.className = 'rb-qa-pills js-rb-qa-pills';
    sizes.forEach(function (size) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rb-qa-pill js-rb-qa-pill';
      b.dataset.size = size;
      b.textContent = size;
      wrap.appendChild(b);
    });
    tray.appendChild(wrap);

    wrap.addEventListener('click', function (e) {
      var mine = e.target.closest ? e.target.closest('.js-rb-qa-pill') : null;
      if (!mine) return;
      e.preventDefault();
      e.stopPropagation();
      var size = mine.dataset.size || '';
      var themePill = pillsOf(overlay).filter(function (p) {
        return (p.dataset.size || '') === size;
      })[0];
      if (!themePill) return;

      if (mine.dataset.soldout === '1') {
        showNotify(overlay, size, themePill.dataset.variantId);
        return;
      }
      /* In stock: replay the theme's own pill click. It sets the variant id,
         syncs the final-sale property and submits the tile's form. */
      themePill.click();
      mirrorAddState(mine, themePill);
    });
    return wrap;
  }

  /* The theme animates ITS pill (is-loading / is-added / is-error) after a
     click, but that pill is hidden, so copy the classes onto the visible one. */
  function mirrorAddState(mine, themePill) {
    var original = mine.textContent;
    mine.classList.add('is-loading');
    var seen = new MutationObserver(function () {
      ['is-loading', 'is-added', 'is-error'].forEach(function (c) {
        mine.classList.toggle(c, themePill.classList.contains(c));
      });
      if (!themePill.classList.contains('is-loading') &&
          !themePill.classList.contains('is-added') &&
          !themePill.classList.contains('is-error')) {
        mine.textContent = original;
        seen.disconnect();
      }
    });
    seen.observe(themePill, { attributes: true, attributeFilter: ['class'] });
    setTimeout(function () {
      seen.disconnect();
      mine.classList.remove('is-loading', 'is-added', 'is-error');
      mine.textContent = original;
    }, 4000);
  }

  /* ------------------------------------------------------------- E: select */

  function buildSelect(overlay, tray, sizes) {
    var row = document.createElement('div');
    row.className = 'rb-qa-select-row';

    /* The select needs its own positioned wrapper: theme.css sets
       appearance:none on every select site-wide and draws the chevron as a
       separate glyph on a .selector-wrapper, so a bare select has no arrow. */
    var wrap = document.createElement('div');
    wrap.className = 'rb-qa-select-wrap';

    var select = document.createElement('select');
    select.className = 'rb-qa-select js-rb-qa-select';
    select.setAttribute('aria-label', 'Choose a size');
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Size';
    select.appendChild(placeholder);
    sizes.forEach(function (size) {
      var option = document.createElement('option');
      option.value = size;
      option.textContent = size;
      select.appendChild(option);
    });

    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'rb-qa-select-add js-rb-qa-add';
    add.textContent = 'Add';
    add.disabled = true;

    wrap.appendChild(select);
    row.appendChild(wrap);
    row.appendChild(add);
    tray.appendChild(row);

    /* Sold-out options stay SELECTABLE now — picking one flips the button to
       "Notify" rather than being a dead end. */
    function refreshButton() {
      var opt = select.options[select.selectedIndex];
      var out = !!(opt && opt.dataset.soldout === '1');
      add.disabled = !select.value;
      add.textContent = out ? 'Notify' : 'Add';
      add.classList.toggle('rb-qa-select-add--notify', out);
    }
    select.addEventListener('change', refreshButton);
    select.__rbRefreshButton = refreshButton;

    add.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var size = select.value;
      if (!size) return;
      var themePill = pillsOf(overlay).filter(function (p) {
        return (p.dataset.size || '') === size;
      })[0];
      if (!themePill) return;

      var opt = select.options[select.selectedIndex];
      if (opt && opt.dataset.soldout === '1') {
        showNotify(overlay, size, themePill.dataset.variantId);
        return;
      }

      var original = add.textContent;
      add.classList.remove('is-added', 'is-error');
      add.disabled = true;
      add.textContent = 'Adding…';

      var $ = window.jQuery;
      var done = function (success) {
        add.classList.add(success ? 'is-added' : 'is-error');
        add.textContent = success ? 'Added ✓' : 'Try again';
        setTimeout(function () {
          add.classList.remove('is-added', 'is-error');
          add.textContent = original;
          refreshButton();
        }, success ? 1400 : 1800);
      };
      if ($) {
        $('body').one('afterAddItem.ajaxCart', function () { done(true); });
        $('body').one('ajaxError.ajaxCart afterCartLoadFail.ajaxCart', function () { done(false); });
      } else {
        setTimeout(function () { done(true); }, 1200);
      }

      themePill.click();
      releaseFocus(overlay);
    });

    return select;
  }

  /* ------------------------------------------------------------ mirroring */

  /* Single source of truth: whatever quick-add-overlay.js decided about each
     theme pill, copied onto whichever control we are showing. Sold-out entries
     are never removed — the shopper sees the full run and can ask to be told
     when a gone size returns. */
  function sync(overlay) {
    var themePills = pillsOf(overlay);

    var select = overlay.querySelector('.js-rb-qa-select');
    if (select) {
      themePills.forEach(function (pill) {
        var size = pill.dataset.size || '';
        var option = select.querySelector('option[value="' +
          (window.CSS && CSS.escape ? CSS.escape(size) : size) + '"]');
        if (!option) return;
        var out = !!pill.disabled;
        option.dataset.soldout = out ? '1' : '0';
        option.disabled = false; // selectable so it can reach the notify form
        option.textContent = out ? size + ' — sold out' : size;
      });
      if (select.__rbRefreshButton) select.__rbRefreshButton();
    }

    var mine = overlay.querySelectorAll('.js-rb-qa-pill');
    if (mine.length) {
      Array.prototype.forEach.call(mine, function (b) {
        var size = b.dataset.size || '';
        var pill = themePills.filter(function (p) { return (p.dataset.size || '') === size; })[0];
        b.dataset.soldout = (pill && pill.disabled) ? '1' : '0';
        b.setAttribute('aria-label', (pill && pill.disabled) ? size + ' — sold out, get notified' : size);
      });
    }

    // A colour change can invalidate a notify form that is open on screen.
    if (overlay.classList.contains('rb-qa-notify-mode')) hideNotify(overlay);
  }

  /* theme.css holds the overlay open on `.quick-add-overlay:focus-within` so
     keyboard users can reach the pills. A <select> or the email input keeps
     focus after use, which pinned the tray open on the card even after the
     mouse left. Blur on mouse-out only, so keyboard focus still holds it. */
  function releaseFocus(overlay) {
    var active = document.activeElement;
    if (active && active !== document.body && overlay.contains(active)) active.blur();
  }

  function decorate(overlay) {
    if (overlay.__rbQaTray) return;
    var pillsWrap = overlay.querySelector('.quick-add-overlay__pills');
    if (!pillsWrap) return; // no size option — single Add button, leave it alone
    overlay.__rbQaTray = true;

    var themePills = pillsOf(overlay);
    var sizes = themePills.map(function (p) { return p.dataset.size || ''; })
                          .filter(function (s) { return s !== ''; });
    if (!sizes.length) return;

    var tray = document.createElement('div');
    tray.className = 'rb-qa-tray';
    var label = document.createElement('div');
    label.className = 'rb-qa-tray__label';
    label.innerHTML = '<span>Select size</span>';
    tray.appendChild(label);

    pillsWrap.parentNode.insertBefore(tray, pillsWrap);
    tray.appendChild(pillsWrap);           // theme pills ride along, hidden by CSS
    overlay.classList.add('rb-qa-managed'); // CSS hides .quick-add-overlay__pills

    if (sizes.length >= SELECT_THRESHOLD) {
      overlay.classList.add('rb-qa-select-mode');
      buildSelect(overlay, tray, sizes);
    } else {
      buildPills(overlay, tray, sizes);
    }
    buildNotify(overlay, tray);
    sync(overlay);

    /* Equal columns, sized to the widest LABEL in this product's run. The old
       flex rule used min-width:max-content to avoid clipping long labels
       ("XX- Large") but paid for it with a stretched orphan pill at 5 sizes and
       uneven rows at 6; measuring the widest label and feeding it to the grid
       min gets both — equal columns and nothing clipped.

       Measured with a Range, NOT scrollWidth: the sold-out pill's diagonal is a
       ::after inset to -14%, so it overflows the box by design and inflates
       scrollWidth by ~15px. Using scrollWidth here reports phantom clipping on
       every sold-out pill and oversizes the column. */
    var widest = 28;
    Array.prototype.forEach.call(overlay.querySelectorAll('.js-rb-qa-pill'), function (p) {
      var range = document.createRange();
      range.selectNodeContents(p);
      var w = range.getBoundingClientRect().width;
      if (w > widest) widest = w;
    });
    overlay.style.setProperty('--rb-qa-pill-min', Math.min(Math.ceil(widest) + 10, 90) + 'px');

    var card = overlay.closest('.product-card') || overlay.parentElement;
    if (card) {
      card.addEventListener('mouseleave', function () {
        releaseFocus(overlay);
        hideNotify(overlay); // don't leave a half-typed email on a card
      });
    }

    /* quick-add-overlay.js toggles pill[disabled] on init and whenever a colour
       swatch is clicked. Watch for that rather than guessing at script order. */
    new MutationObserver(function () { sync(overlay); })
      .observe(pillsWrap, { attributes: true, subtree: true, attributeFilter: ['disabled'] });
  }

  /* mouseleave is the right release on a mouse, but a touchscreen LAPTOP
     matches (hover: hover) — so the :focus-within rule applies there — while a
     touch user may never generate a mouseleave. pointerdown covers mouse, touch
     and pen in one listener: any interaction landing outside the card releases
     the focus that was pinning that card's tray open. Bound once, not per
     overlay. (A pure touch tablet reports hover:none, so the focus-within rule
     never applies there and only .is-open governs, which quick-add-overlay.js
     already clears on outside click.) */
  document.addEventListener('pointerdown', function (e) {
    var active = document.activeElement;
    if (!active || active === document.body || !active.classList) return;
    if (!active.classList.contains('js-rb-qa-select') &&
        !active.classList.contains('js-rb-qa-add') &&
        !active.classList.contains('js-rb-qa-email')) return;
    var overlay = active.closest('.js-quick-add-overlay');
    if (!overlay) return;
    var card = overlay.closest('.product-card') || overlay.parentElement;
    if (card && card.contains(e.target)) return; // still inside this card
    active.blur();
  }, true);

  function run() {
    document.querySelectorAll('.js-quick-add-overlay').forEach(decorate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Filter changes, pagination and infinite scroll inject new cards. */
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.classList && n.classList.contains('js-quick-add-overlay')) decorate(n);
        if (n.querySelectorAll) n.querySelectorAll('.js-quick-add-overlay').forEach(decorate);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


/* ==== rooster-sticky-sidebar.js ==== */
;/* =====================================================================
   Rooster Bus — JS sticky sidebar fallback (v3 — direct viewport)
   ---------------------------------------------------------------------
   CSS `position: sticky` keeps breaking on the live storefront because
   an app injects overflow:hidden / transform / contain onto an ancestor
   element, which silently disables sticky on every descendant. CSS-only
   fixes can't reliably defeat that — the app's injection happens at
   runtime, after our stylesheet loads.

   This script translates the sidebar so it stays parked at a constant
   viewport offset as you scroll. Two key principles:

   1. Each frame we read the COLUMN's current bounding rect — that's its
      live viewport-relative top. We translate so the sidebar's top sits
      at `headerOffset`. No scroll-position math, no document-coord
      bookkeeping that could drift if the page reflows. (Earlier versions
      cached `columnPageTop` and computed against `scrollY`, which broke
      when the header CSS variable changed value mid-scroll and shifted
      the cached headerOffset.)
   2. `headerOffset` is locked at init and only re-measured on window
      resize. It never reacts to body.header-up so the header hiding /
      showing on scroll can't drag the sidebar with it.

   Re-initializes itself after Shopify section reloads (theme editor)
   and after the DynamicProductSearch AJAX swap (filter/sort changes).
   ===================================================================== */
(function () {
  'use strict';

  function rafThrottle(fn) {
    var ticking = false;
    return function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        fn();
        ticking = false;
      });
    };
  }

  function measureHeaderOffset() {
    var rootStyle = window.getComputedStyle(document.documentElement);
    var cssVar = rootStyle.getPropertyValue('--header-section-height').trim();
    if (cssVar) {
      var n = parseInt(cssVar, 10);
      if (!isNaN(n) && n > 0) return n + 4;
    }
    var header = document.querySelector('.js-header, .shopify-section-header');
    if (header) return header.offsetHeight + 4;
    return 94;
  }

  function setupSticky(sidebar) {
    if (!sidebar || sidebar.__rbStickyInited) return;
    sidebar.__rbStickyInited = true;

    var column = sidebar.parentElement;
    while (column && !column.classList.contains('o-layout__item')) {
      column = column.parentElement;
    }
    if (!column) return;

    // Compositor promotion + neutralize any inherited positioning.
    sidebar.style.position = 'relative';
    sidebar.style.top = '0';
    sidebar.style.willChange = 'transform';
    sidebar.style.backfaceVisibility = 'hidden';
    sidebar.style.transform = 'translate3d(0,0,0)';

    // Locked at init. Only re-measured on window resize.
    var headerOffset = measureHeaderOffset();

    // Sidebar's natural offset within column + heights for clamping.
    // Recomputed only on resize / DOM mutation, never per-scroll-frame.
    var cache = {
      sidebarOffsetTop: 0,
      sidebarHeight: 0,
      columnHeight: 0,
      maxTranslate: 0
    };

    var lastTranslate = 0;

    function recalc() {
      // Reset transform so we measure the natural offset.
      var prev = sidebar.style.transform;
      sidebar.style.transform = 'translate3d(0,0,0)';

      cache.sidebarOffsetTop = sidebar.offsetTop;
      cache.sidebarHeight = sidebar.offsetHeight;
      cache.columnHeight = column.offsetHeight;
      cache.maxTranslate = Math.max(
        0,
        cache.columnHeight - cache.sidebarHeight - cache.sidebarOffsetTop
      );

      sidebar.style.transform = prev;

      // Force update since cache changed.
      lastTranslate = -1;
      update();
    }

    function update() {
      // Live viewport-relative top of the column. This already accounts
      // for scroll position AND any page reflow that may have happened
      // (e.g. header hiding/showing). The sidebar's transform doesn't
      // affect the column's box, so this measurement is stable regardless
      // of our previous translate.
      var columnTop = column.getBoundingClientRect().top;

      // Without transform, sidebar's viewport top would be at
      //   columnTop + cache.sidebarOffsetTop
      // We want it at `headerOffset`, so:
      var desired = headerOffset - columnTop - cache.sidebarOffsetTop;

      // Clamp: never translate up (translate < 0) and never past the
      // bottom of the column.
      var translate = desired < 0
        ? 0
        : (desired > cache.maxTranslate ? cache.maxTranslate : desired);

      if (translate !== lastTranslate) {
        sidebar.style.transform = 'translate3d(0,' + translate + 'px,0)';
        lastTranslate = translate;
      }
    }

    function onWindowResize() {
      headerOffset = measureHeaderOffset();
      recalc();
    }

    var onScroll = rafThrottle(update);
    var onResize = rafThrottle(onWindowResize);
    var onRO = rafThrottle(recalc);

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(onRO);
      ro.observe(sidebar);
      ro.observe(column);
    }

    recalc();
  }

  function init() {
    if (!document.body.classList.contains('template-collection')) return;

    var sidebars = document.querySelectorAll('.collection-sidebar');
    sidebars.forEach(function (sidebar) {
      if (sidebar.closest('.mfp-content, .mfp-container')) return;
      setupSticky(sidebar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 0);
  });

  // Re-init after the DynamicProductSearch AJAX swap.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'childList' && m.addedNodes.length) {
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType === 1) {
            if (
              (node.classList && node.classList.contains('collection-sidebar')) ||
              (node.querySelector && node.querySelector('.collection-sidebar'))
            ) {
              setTimeout(init, 0);
              return;
            }
          }
        }
      }
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();


/* ==== rooster-commerce.js ==== */
;(function () {
  function closestFrom(node, selector) {
    // Click targets are not always Elements (library-dispatched events can land on
    // document, window or a text node) and only Element has closest().
    if (!node || typeof node.closest !== 'function') return null;
    return node.closest(selector);
  }

  function pushEvent(name, details) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, details || {}));
    if (typeof window.gtag === 'function') window.gtag('event', name, details || {});
  }

  function isSaleVariant(variant) {
    if (!variant) return false;
    var price = Number(variant.price || 0);
    var compareAt = Number(variant.compare_at_price || 0);
    return compareAt > price;
  }

  function syncFinalSale(form, variant) {
    if (!form) return;
    var finalSale = isSaleVariant(variant);
    var note = form.querySelector('[data-final-sale-note]');
    if (note) note.hidden = !finalSale;
    // 2026-09-04: delegate to ensure(), which CREATES and REMOVES the inputs.
    // Toggling .disabled is no longer a valid way to clear the flag: Shopify's
    // accelerated checkout (Buy it now / Shop Pay) collects properties[...]
    // inputs by name and never reads `disabled`. Only absence works.
    if (window.RoosterFinalSale && window.RoosterFinalSale.ensure) {
      window.RoosterFinalSale.ensure(form, finalSale,
        variant && variant.compare_at_price, variant && variant.price, 'pdp');
      return;
    }
    var property = form.querySelector('[data-final-sale-property]');
    var basis = form.querySelector('[data-final-sale-basis]');
    if (property && !finalSale && property.parentNode) property.parentNode.removeChild(property);
    if (basis && !finalSale && basis.parentNode) basis.parentNode.removeChild(basis);
  }

  document.addEventListener('variants:change', function (event) {
    var form = closestFrom(event.target, '.product-single__box')
      ? closestFrom(event.target, '.product-single__box').querySelector('form[action*="/cart/add"]')
      : document.querySelector('.product-single form[action*="/cart/add"]');
    syncFinalSale(form, event.detail && event.detail.variant);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('form[role="search"]')) return;
    var input = form.querySelector('input[name="q"]');
    pushEvent('rooster_search_submit', { search_term: input ? input.value.trim() : '' });
  });

  document.addEventListener('click', function (event) {
    var tracked = closestFrom(event.target, '[data-rooster-event]');
    if (tracked) pushEvent(tracked.getAttribute('data-rooster-event'), { link_url: tracked.href || '' });

    var pickup = closestFrom(event.target, 'pickup-availability, .store-availability-container, [data-store-availability-modal-open]');
    if (pickup) pushEvent('rooster_pickup_interest');

  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.closest('.promo-page, [data-section-type="newsletter"], .klaviyo-form')) return;
    pushEvent('rooster_promo_signup_submit');
  });

  if (window.jQuery) {
    window.jQuery(document.body).on('afterAddItem.ajaxCart', function (event, lineItem) {
      var properties = lineItem && lineItem.properties;
      pushEvent('rooster_add_to_cart', {
        product_id: lineItem ? String(lineItem.product_id || '') : '',
        variant_id: lineItem ? String(lineItem.variant_id || '') : '',
        quantity: lineItem ? Number(lineItem.quantity || 1) : 1,
        value: lineItem ? Number(lineItem.final_price || lineItem.price || 0) / 100 : 0,
        currency: window.Shopify && Shopify.currency ? Shopify.currency.active : '',
        final_sale: !!(properties && (properties._final_sale === true || properties._final_sale === 'true'))
      });
    });
  }
})();


/* ==== details-disclosure.js ==== */
;class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content =
      this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      'focusout',
      this.onFocusOut.bind(this),
    );
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);


/* ==== header-details-disclosure.js ==== */
;class HeaderDetailsDisclosure extends DetailsDisclosure {
  #summaryLink;

  constructor() {
    super();

    this.#summaryLink = this.querySelector('summary > a');

    if (!this.mainDetailsToggle.hasAttribute('open'))
      this.#disableSummaryLink();

    this.mainDetailsToggle.addEventListener('mouseenter', () => {
      if (
        !document
          .querySelector('body')
          .hasAttribute('header-details-disclosure-edit')
      )
        this.open();
    });

    this.mainDetailsToggle.addEventListener('mouseleave', () => {
      if (
        !document
          .querySelector('body')
          .hasAttribute('header-details-disclosure-edit')
      )
        this.close();
    });

    // Close the mega menu on Escape (accessibility) and on page scroll.
    document.addEventListener('keyup', (event) => {
      if (
        event.code === 'Escape' &&
        this.mainDetailsToggle.hasAttribute('open')
      )
        this.close();
    });

    window.addEventListener(
      'scroll',
      () => {
        if (this.mainDetailsToggle.hasAttribute('open')) this.close();
      },
      { passive: true },
    );
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.querySelector('summary').setAttribute('aria-expanded', true);

    if (
      this.content.getBoundingClientRect().x + this.content.offsetWidth >
      window.innerWidth - 30
    ) {
      this.content.classList.add('is-left-aligned');
    }

    if (this.hasAttribute('adjust-mega-menu-height'))
      this.#setContentHeight(36);
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle
      .querySelector('summary')
      .setAttribute('aria-expanded', false);

    this.content.classList.remove('is-left-aligned');

    if (this.hasAttribute('adjust-mega-menu-height'))
      this.#removeContentHeight();
  }

  onToggle() {
    if (!this.panelAnimations)
      this.panelAnimations = this.content.getAnimations();
    if (!this.contentAnimations) {
      this.contentAnimations = Array.from(
        this.querySelectorAll('.has-animation'),
      ).reduce((animations, element) => {
        const animation = element.getAnimations();
        return [...animations, ...animation];
      }, []);
    }

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.#enableSummaryLink();
      // dropdown animation reset
      this.panelAnimations.forEach((animation) => animation.play());
      // mega items animation reset
      this.contentAnimations.forEach((animation) => animation.play());

      document.body.setAttribute('header-menu-open', '');
    } else {
      this.#disableSummaryLink();
      // dropdown animation cancel
      this.panelAnimations.forEach((animation) => animation.cancel());
      // mega items animation cancel
      this.contentAnimations.forEach((animation) => animation.cancel());

      document.body.removeAttribute('header-menu-open', '');
    }
  }

  #setContentHeight(padding = 0) {
    const headerSection = document.querySelector('.js-header');
    const headerBottomBoundary =
      headerSection && headerSection.getBoundingClientRect().bottom > 0
        ? headerSection.getBoundingClientRect().bottom
        : 0;
    const combinedPanelCutoff = Math.round(headerBottomBoundary + padding);

    if (this.content.offsetHeight > window.innerHeight - combinedPanelCutoff) {
      this.content.style.setProperty(
        '--header-elements-height',
        `${combinedPanelCutoff}px`,
      );
      this.content.classList.add('has-height-control');
    }
  }

  #removeContentHeight() {
    this.content.classList.remove('has-height-control');
  }

  #summaryLinkListener(e) {
    e.preventDefault();
  }

  #enableSummaryLink() {
    if (this.#summaryLink)
      this.#summaryLink.removeEventListener('click', this.#summaryLinkListener);
  }

  #disableSummaryLink() {
    if (this.#summaryLink)
      this.#summaryLink.addEventListener('click', this.#summaryLinkListener);
  }
}

customElements.define('header-details-disclosure', HeaderDetailsDisclosure);

